export default __webpack_public_path__ + "static/media/save.db499061.svg";